import { useCompanyValues } from '@/providers';
import { useGetUserInfoQuery } from '@/services/endpoints/users';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { TermsAndConditionsModal } from '../TermsAndConditions';
import { ExternalFooter, Footer } from './Footers';
import { LayoutRoutes } from './Layout.routes';
import { ExternalSidebar, Sidebar } from './Sidebars';
import { useGetConnectorTranslationsQuery } from '@/services/endpoints/workspace-connectors';

const Layout: FC = () => {
  useGetConnectorTranslationsQuery();

  const { isDefault } = useCompanyValues();

  const { data: userInfo } = useGetUserInfoQuery();

  return (
    <>
      <div className='flex h-dvh flex-col overflow-hidden' data-testid='layout'>
        <div className='relative flex min-h-0 flex-1'>
          {isDefault ? <Sidebar /> : <ExternalSidebar />}
          <div
            className={twMerge(
              // min-w-0: without it this flex item floors at its content's min-content width and
              // pushes the whole shell past the viewport (the h-dvh wrapper then clips the excess)
              'flex min-h-0 min-w-0 flex-1 flex-col ps-sidebar-short peer-data-[pinned=true]:ps-sidebar-full',
              'motion-safe:transition-[padding] motion-safe:duration-500 motion-reduce:transition-none'
            )}
          >
            <main className='relative flex size-full min-w-0 flex-col overflow-y-auto bg-primary-background'>
              <LayoutRoutes />
            </main>
          </div>
        </div>
        {isDefault ? <Footer /> : <ExternalFooter />}
      </div>
      {!userInfo?.termsAccepted && <TermsAndConditionsModal />}
    </>
  );
};

export default Layout;
